import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as clientApi from '../Api/clientApi';

const CLIENT_KEY = 'clients';

export const useClients = (companyId) =>
	useQuery({
		queryKey: [CLIENT_KEY, companyId],
		queryFn: async () => {
			const result = await clientApi.getClients();
			return result.data.clients;
		},
		enabled: !!companyId,
	});

export const useClient = (id) =>
	useQuery({
		queryKey: [CLIENT_KEY, id],
		queryFn: async () => {
			const response = await clientApi.getClient(id);
			return response.data;
		},
		enabled: !!id,
	});

export const useCreateClient = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ clientData }) => clientApi.createClient(clientData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CLIENT_KEY] });
		},
	});
};

export const useUpdateClient = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, clientData }) => clientApi.updateClient(id, clientData),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CLIENT_KEY] });
		},
	});
};

export const useDeleteClient = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id }) => clientApi.deleteClient(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [CLIENT_KEY] });
		},
	});
};

export const useInvoicesForClient = (clientId) =>
	useQuery({
		queryKey: [CLIENT_KEY, clientId, 'invoices'],
		queryFn: async () => {
			const response = await clientApi.getInvoicesForClient(clientId);
			return response.data || response;
		},
		enabled: !!clientId,
	});

// Note: Logo upload now happens directly to Uploadthing via UploadthingWidget
// No need for backend upload endpoint - companyLogo is saved when client is created/updated
